import { useMobileControlToggles } from 'hooks/useMobileControlToggles.module'

import DeckViewAsDropdown from 'components/deckPage/filtersAndControls/DeckViewAsDropdown'
import DeckGroupByDropdown from 'components/deckPage/filtersAndControls/DeckGroupByDropdown'
import DeckSortByDropdown from 'components/deckPage/filtersAndControls/DeckSortByDropdown'
import ChangePriceSource from 'components/deckPage/filtersAndControls/ChangePriceSource'
import DeckFilter from '../DeckFilter'
import DeckLayoutPresenter from 'components/deckPage/DeckLayoutPresenter'
import ToggleSwitch from 'components/formElements/ToggleSwitch'

import styles from './mobileLayoutControls.module.scss'

const MobileLayoutControls = () => {
  const [mobileLayoutControls, setMobileLayoutControls] = useMobileControlToggles()

  const handleScrollToTopOfDeckContainer = () => {
    const deckContainer = document.getElementById('deck-container')

    if (!deckContainer) return

    const scrollPosition = deckContainer.getBoundingClientRect().top + window.pageYOffset - 50

    window.scrollTo({ top: scrollPosition, behavior: 'instant' })
  }

  return (
    <div className={styles.container}>
      <DeckViewAsDropdown onViewAsChange={handleScrollToTopOfDeckContainer} />
      <DeckGroupByDropdown />
      <DeckSortByDropdown />
      <ChangePriceSource />

      <DeckFilter />

      <DeckLayoutPresenter
        className={styles.layoutPresenter}
        label={'Example layouts. All layouts below can be configured using the tools above.'}
      />

      <div className={styles.cachableOptions}>
        <h3>Pin options above the deck</h3>
        <ToggleSwitch
          label="View as"
          checked={mobileLayoutControls.view}
          onChange={view => setMobileLayoutControls({ view })}
        />

        <ToggleSwitch
          label="Group by"
          checked={mobileLayoutControls.group}
          onChange={group => setMobileLayoutControls({ group })}
        />

        <ToggleSwitch
          label="Sort by"
          checked={mobileLayoutControls.sort}
          onChange={sort => setMobileLayoutControls({ sort })}
        />

        <ToggleSwitch
          label="Prices"
          checked={mobileLayoutControls.prices}
          onChange={prices => setMobileLayoutControls({ prices })}
        />

        <ToggleSwitch
          label="Deck filter"
          checked={mobileLayoutControls.deckFilter}
          onChange={deckFilter => setMobileLayoutControls({ deckFilter })}
        />
      </div>
    </div>
  )
}

export default MobileLayoutControls
